export interface CountryStats {
  iso: string;
  level: number;
  consecutiveCorrect: number;
  consecutiveWrong: number;
  lastSeen: number;
  totalCorrect: number;
  totalWrong: number;
}

export interface RegionProgress {
  cleared: boolean;
  clearedAt: number | null;
}

export interface AppSettings {
  fuzzyMatchTolerance: number;
  showHints: boolean;
}

export type ArcadeMode = "speed-run" | "survival" | "reverse";

export interface ArcadeBest {
  // Mode-dependent meaning:
  //   speed-run → correct count in 60s
  //   survival  → longest streak
  //   reverse   → correct out of 10
  score: number;
  achievedAt: number;
}

// Keyed by `${mode}:${region}` for cheap lookup. Region is the same
// human-readable string used by the learn loop (e.g. "Europe").
export type ArcadeBests = Record<string, ArcadeBest>;

export interface LeaderboardEntry {
  username: string;
  score: number;
  achievedAt: number;
}

export interface CachedLeaderboard {
  entries: LeaderboardEntry[];
  fetchedAt: number;
}

// Keyed by `${mode}:${region}`, same shape as arcadeBests so cache reads
// stay symmetrical. Lets the leaderboard view render instantly from local
// state, with the network call refreshing behind it.
export type CachedLeaderboards = Record<string, CachedLeaderboard>;

export interface AppState {
  version: 2;
  stats: Record<string, CountryStats>;
  regionProgress: Record<string, RegionProgress>;
  arcadeBests: ArcadeBests;
  settings: AppSettings;
  // Claimed username for the global leaderboard. Null until the user
  // claims one via the settings UI.
  username: string | null;
  cachedLeaderboards: CachedLeaderboards;
}

export const APP_STATE_KEY = "geo-app-state-v1";
export const CURRENT_STATE_VERSION = 2 as const;
